import { GetMethod, PostMethod } from '../../../serviceHelper';

const getMethods = (service: 'dm', controller: 'DocumentManagement/RecycleBin') => ({
	GetSettings: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetSettings'
	}),
	UpdateSettings: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateSettings'
	}),
	GetItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetItems'
	}),
	RestoreItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'RestoreItem'
	}),
	RestoreItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'RestoreItems'
	}),
	DeleteItems: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteItems'
	}),
	DeleteItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteItem'
	}),
	DeleteAll: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteAll'
	})
});

export { getMethods };
